<nav class="menuSocial" *ngIf="rrss?.length > 0">
  <div *ngFor="let rs of rrss; index as i">
    <a href="{{rs.url}}" title="" target="_blank" rel="nofollow">{{rs.titulo}}</a>
  </div>
</nav>
